import type { SchemaViewerFormItemLabelProps } from "./schema-viewer-form-item-label.type";

import { useTranslation } from "react-i18next";

import { SchemaViewerFieldExpressionLabel } from "@/modules/schema-viewer/schema-viewer-field-expression-label";

export const SchemaViewerFormItemLabel = ({
  schema,
}: SchemaViewerFormItemLabelProps) => {
  const { t } = useTranslation();

  const { type, label, model } = schema;
  const isCheckboxField = type === "checkbox";
  const isExpressionField = type === "expression";

  if (isCheckboxField) {
    return undefined;
  }

  const fieldLabel = t(`form:staticField.${model}.label`, label);

  if (isExpressionField) {
    return (
      <SchemaViewerFieldExpressionLabel
        label={fieldLabel}
        expressionSchema={schema}
      />
    );
  }

  return <>{fieldLabel}</>;
};
